import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Card } from '../../../../components/ui/card';
import { profileQueryOptions } from '../../../../lib/business';
import { useSession } from '../../../../lib/session';

export const Route = createFileRoute('/subdomain/app/_client/')({
  component: ClientHome,
});

// TODO(Sprint 2): replace with the real Home dashboard (Figma C02.2). This is only a landing page so the
// auth + onboarding flow has somewhere to end.
function ClientHome() {
  const { data: session } = useSession();
  const { data: profile } = useQuery(profileQueryOptions);

  return (
    <main className="flex flex-col gap-(--mbm-space-6) px-(--mbm-space-4) py-(--mbm-space-6) lg:px-(--mbm-space-9) lg:py-(--mbm-space-7)">
      <h1 className="text-display text-text-strong">Hi{session?.user.name ? `, ${session.user.name}` : ''}</h1>
      <Card padding="lg" className="max-w-(--mbm-layout-settings-content-width)">
        <p className="text-body-medium text-text-secondary">
          {profile ? `${profile.businessName} is set up.` : 'Your business is set up.'} Your dashboard is on its way.
        </p>
      </Card>
    </main>
  );
}
